'use strict';

var countries = require('./countries'),
	reCaptcha = require('int_recaptcha/recaptcha'),
	cq = require('./cq'),
	dialog = require('./dialog'),
	minicart = require('./minicart'),
	multicurrency = require('./multicurrency'),
	rating = require('./rating'),
	searchplaceholder = require('./searchplaceholder'),
	searchsuggest = require('./searchsuggest'),
	tooltip = require('./tooltip'),
	util = require('./util'),
	einstein = require('./einstein'),
	validator = require('./validator'),
	navigation = require('./navigation'),
	stickup = require('./stickup'),
	iscrollexample = require('./iscrollexample'), //used as an example for working with custom scrolls
	lcgResponsive = require('./lcg_responsive'),
	ecommBridge = require('./ecom-bridge'),
	emailsignup = require('./emailsignup'),
	quickview = require('./quickview'),
	addToCart = require('./pages/product/addToCart'),
	contentloader = require('./contentloader'),
	loqate = require('./loqate'),
	lazyloading = require('./lazyloading'),
	tls = require('./tls'),
	amazonpay = require('./pages/checkout/amazonPay'),
	wishlist = require('./pages/wishlist'),
	cjcookie = require('./cjcookie');

window.ecommBridge = ecommBridge;
require('./jquery-ext')();
require('./cookieprivacy')();

function initializeEvents() {
	searchsuggest.init($('#header-search'), Resources.SIMPLE_SEARCH);

	// print handler
	$('.print-page').on('click', function () {
		window.print();
		return false;
	});

	handleToggleElements();

	// Third handler for toggles Secondary Content Navigation
	$('.content-menu-mobile').on('click', function () {
		$(this).parents('.secondary_content_nav').toggleClass('active');
	});

	manageFooterMenu();
	handleFooterSignupFocus();

	var $storefrontInputs = $('select, input[type=radio],input[type=checkbox]');
	$storefrontInputs = $storefrontInputs.filter(function () {
		return $(this).parents('#onetrust-pc-sdk').length === 0;
	});
	$storefrontInputs.uniform();

	$('select').on('change', function () {
		if ($(this).parent().hasClass('selector') && $(this).parent().hasClass('focus')) {
			$(this).parent().removeClass('focus');
		}
	});

	// Activate Global tabs/accordions for content pages
	$('.global-tabs').tabs();

	$(window).smartresize(function () {
		if (!$('.billing-section-content').length) {
			setTimeout(function () {
				$.uniform.update();
			}, 20);
		}
	});

	$('.currencySelector .selected').on('click', function () {
		$(this).parent().toggleClass('visible');
	});

	initHeaderMenuDropdowns();

	handleAccountNavDisplay();

	initSearchDisplayBehavior();

	initContentCarousels();

	// Init Add To Cart links from content assets / slots
	addToCart(null, true);

	initQuickViewFromContent();

	//gift guru top panel
	$('.js-gift-guru-carry-on-btn, .js-gift-guru-info-icon').on('click', function () {
		$('.js-gift-guru-banner').toggleClass('gift-guru-top-menu-closed');
	});

	function fireReadyResize() {
		if (util.viewport.isMobile() === false) {
			$('.toggle.expanded').next('ul, .toggle-content').show();

		} else {
			$('.toggle').removeClass('expanded');
			$('.toggle').next('ul, .toggle-content').hide();

		}
		// Global tabs/accordions
		lcgResponsive.move(util.viewport.isMobile(), '.global-tabs-move', '.tab-target-mobile', '.tab-target-desktop');
		//do not apply this for pdp
		if (window.pageContext && window.pageContext.ns !== 'product') {
			lcgResponsive.tabAccordMobile(util.viewport.isMobile());
		}
	}

	fireReadyResize();
	$(window).smartresize(fireReadyResize);

	// Fix uk postcode validation errors after PCA auto-complete
	// Convert postcode field value to upper case
	$(document).on('input', 'input.postcode', function () {
		var val = $(this).val();
		if (val) {
			$(this).val(val.toUpperCase());
		}
	});

	manageMobileOnlyCarousel();
	$(window).on('resize', manageMobileOnlyCarousel);

	$('.js-accordion').accordion({
		heightStyle: 'content',
		active: false,
		collapsible: true,
		icons: {
			header: 'iconClosed',
			activeHeader: 'iconOpen'
		},
		animate: 300
	});

	openPromotionDialog();

	$('.password-show-button').on('click', function () {
		$(this).toggleClass('password-shown');
		var password = $('input[name*=_password');
		password.attr('type', password.attr('type') === 'password' ? 'text' : 'password');
	});

	$('body').on('click', '.summary-title .expand-btn, .summary-title .collapse-btn', function () {
		$(this).addClass('hidden');
		$(this).siblings('.expand-btn, .collapse-btn').removeClass('hidden');
		$(this).closest('.summary-title').next().toggle();
	});

	initSliderWithProgressBar();

	manageMobileExpandableText();
	$(window).on('resize', manageMobileExpandableText);
}

/**
 * Main handler for toggles where heading changes its color and background color
 */
function handleToggleElements() {
	$('.toggle-title').on('click', function (e) {
		$(this).toggleClass('on').next('.toggleContent').toggleClass('show');
		e.preventDefault();
	});
	$('.toggle.expanded').closest('li').addClass('active');
	$('.toggle').click(function () {
		$(this).toggleClass('expanded').next('ul, .toggle-content').toggle();
		$(this).closest('li').toggleClass('active', $(this).hasClass('expanded'));
	});
}

/**
 * Handler for footer menu on mobile devices
 */
function manageFooterMenu() {
	$('footer .line2 ul.footerMenu li > a').on('click', function (e) {
		if (util.viewport.isMobile()) {
			if ($(this).siblings('ul').length && !$(this).parent().hasClass('active')) {
				e.preventDefault();
				$(this).parent().addClass('active');
			}
		}
	});

	$('footer .line2 ul.footerMenu li > span').on('click', function () {
		if (util.viewport.isMobile()) {
			$(this).parent().toggleClass('active');
		}
	});
}

/**
 * Focus event handler for footer signup form
 */
function handleFooterSignupFocus() {
	$('.input-text.email').focus(function () {
		$(this).parents('.footer-signup').addClass('focus');
	})
	.blur(function () {
		$(this).parents('.footer-signup').removeClass('focus');
	});
}

/*
 * @descr show/hide search form on hover or touchstart.
 * Any opened dropdowns with .hover class get closed, once search form get activated.
 *
 * If either opened search form or search icon looses the focus, search form get closed on desktop devices.
 * If search form is opened and search icon is touched again or any area outside the form is touched,
 * search for is closed @see dropDownUILayer.
 */
function initSearchDisplayBehavior() {
	var $searchIcon = $('.mobile-search-icon'),
	$searchIconContainer = $('.search-toggler'),
	$headerSearch = $('#header-search'),
	isSearchFormInFocus = false;
	$searchIcon.on('touchstart mouseenter', function (e) {
		e.preventDefault();

		if ($searchIconContainer.hasClass('hover') && e.type === 'touchstart') {
			$('body').find('.hover').removeClass('hover');
			$('.uiLayerIndicator').remove();
			return;
		}

		$headerSearch.addClass('hover');
		$searchIconContainer.addClass('hover');
		util.renderClosePadForTouch();

	}).on('mouseleave', function () {
		setTimeout(function () {
			if (!isSearchFormInFocus) {
				$('body').find('.hover').removeClass('hover');
				$('.uiLayerIndicator').remove();
			}
		}, 1000);
	});
	$headerSearch.on('touchstart mouseenter', function () {
		isSearchFormInFocus = true;
	}).on('mouseleave', function () {
		isSearchFormInFocus = false;
		$('body').find('.hover').removeClass('hover');
		$('.uiLayerIndicator').remove();
	});
}

/*
 * Define properties and use slick to initialise content carousels
 * handle number of items in carousel based on container width
 */
function initContentCarousels() {
	$('.content-tiles-slider-container').each(function () {
		var itemMinWidth = 210,
			itemsToShowLength = util.getNumberOfItemsInCarousel($(this), itemMinWidth);
		$(this).find('.content-tiles-slider').slick(util.contentSliderConfig(itemsToShowLength));
	});

	// this event specific to some pages and carousels
	einstein.onEinstainContentAdded('.content-tiles-slider-container-deferred', function () {
		$('.content-tiles-slider-container-deferred:not(.carousel-inited)').each(function () {
			$(this).parents('einstain-inited').addClass('einstain-clear');
			$(this).addClass('carousel-inited');
			var itemMinWidth = ($(this).hasClass('content-tiles-small')) ? 109 : 210,
				itemsToShowLength = util.getNumberOfItemsInCarousel($(this), itemMinWidth);
			$(this).find('.content-tiles-slider:not(.slick-initialized)').slick(util.contentSliderConfig(itemsToShowLength));
		});
	});

	$(window).smartresize(function () {
		$('.content-tiles-slider-container, .content-tiles-slider-container-deferred').each(function () {
			var carousel = $(this).find('.content-tiles-slider'),
				itemMinWidth = (carousel.parent().hasClass('content-tiles-small') ? 109 : 210),
				itemsToShowLength = util.getNumberOfItemsInCarousel($(this), itemMinWidth),
				prevItemsToShowLength;

			if (prevItemsToShowLength !== itemsToShowLength) {
				carousel.slick('slickSetOption', 'slidesToShow', itemsToShowLength, true);
				prevItemsToShowLength = itemsToShowLength;
			}
		});
	});
}

/*
 * Start quick view from content assets / slots
 * Avoid multiple event listeners on quickview buttons
 */
function initQuickViewFromContent() {
	$(document).off('click.globalquickview');
	$(document).on('click.globalquickview', '[data-quick-view-url]', function (e) {
		if (!util.viewport.isMobile()) {
			quickview.show({
				dialogClass: 'quickview-dialog',
				source: 'quickview',
				url: $(this).data('quickViewUrl')
			});
			e.preventDefault();
		}
	});
}

/*
 * Handle showing/hiding account navigation in header
 */
function handleAccountNavDisplay() {
	$('.myaccount-toggle').on('click touchstart', function (e) {
		e.preventDefault();
		$(this).toggleClass('active');
		$(this).next('.ac-nav-ul').toggleClass('active');
	});
	if (util.viewport.isMobile()) {
		$('.myaccount-toggle')
			.filter('.my-account')
			.removeClass('active')
			.next('.ac-nav-ul').removeClass('active');
	}
}

/*
* @descr show/hide dropdowns on hover or touchstart event, that is based on
* window interface capacity.
*
* Handler applies to all dropdowns that implements the basic markup structure with
* main container having class attribute set to 'hover-drop-down'.
*
* All opened dropdowns get closed once another drop down get activated.
* If dropdown's show/hide link is touched while dropdown itself remains active,
* given dropdown get closed (applies to touch devices).
*
* On desktop devices, if dropdown looses the focus, it get closed. That
* eliminates possibility of having more than one dropdown opened.
*/

function initHeaderMenuDropdowns() {
	$('.hover-drop-down').on('touchstart mouseenter', '.menu-title', function (e) {
		var eventType = e.type,
			$container = $(this).closest('.hover-drop-down'),
			$allDropDowns = $('#wrapper').find('.hover');
		if (!$container.hasClass('hover') || eventType !== 'touchstart') {
			e.preventDefault();
			$allDropDowns.removeClass('hover');
			$('.uiLayerIndicator').remove();
			$container.addClass('hover');
			util.renderClosePadForTouch(false, 'dropDown');
			if ($container.is('#hamburger-menu')) {
				navigation.setMenuHeight();
			}
		}
	});
}

/*
 * Slick carousel only for mobile views, destroyed for desktop ones
 */
function manageMobileOnlyCarousel() {
	var carousel = $('.mobile-only-carousel');

	if (util.viewport.isMobile()) {
		carousel.not('.slick-initialized').slick({
			slidesToShow: 2,
			slidesToScroll: 1,
			dots: false,
			arrows: false,
			focusOnSelect: true,
			variableWidth: true
		});
	} else if (carousel.hasClass('slick-initialized')) {
		carousel.slick('unslick');
	}
}

/*
 * Open dialog on PLP, PDP on click of read more link located in promotion custom attribute
 */
function openPromotionDialog() {
	$(document).on('click', '.pdp-promotion-callout.show-more, .read-more-promo-link', function(e) {
		e.preventDefault();
		e.stopPropagation();
		dialog.open({
			html: $(this).parents('.promotion-callout').find('.read-more-promo-content').html(),
			options: {
				title: $(this).attr('title'),
				show: 'drop',
				position: {
					my: 'right top',
					at: 'right top',
					of: window
				},
				height: window.innerHeight,
				dialogClass: 'read-more-promo-dialog'
			}
		});
	});
}

/**
 * * Initialize slick slider with progress bar.
 * On init progress bar is one-third filled and updates after each slide change
 */
function initSliderWithProgressBar() {
	$('.js-slider-with-progress').not('.slick-initialized').slick({
		slidesToShow: 2.33,
		slidesToScroll: 1,
		arrows: true,
		infinite: false,
		responsive: [
			{
				breakpoint: 768,
				settings: {
					arrows: false,
					slidesToShow: 1.2
				}
			}
		]
	}).on('afterChange', function(event, slick, currentSlide) {
		var maxIndex = Math.ceil(slick.slideCount - slick.options.slidesToShow);
		maxIndex = maxIndex > 0 ? maxIndex : 1;
		var additionalProgress = (currentSlide / maxIndex) * 67;
		var progressVal = Math.min(100, 33 + additionalProgress);
		var progressBar = $(this).siblings('.slider-progress-bar-container').find('.slider-progress-bar');
		progressBar.css('width', `${progressVal}%`);
	});
}

/**
 * Truncates text > 200 characters on mobile, hides the rest,
 * adds a "Read more" functionality that displays full text on click.
 * For desktop the text remains full
 */
function manageMobileExpandableText() {
	$('.expandable-text').each(function() {
		var $textElement = $(this);
		var $existingShowFullText = $textElement.find('.show-full-text');

		if (util.viewport.isMobile()) {
			var fullText = $textElement.text();
			if ($existingShowFullText.length || fullText.length < 200) {
				return;
			}

			$textElement.text(fullText.slice(0, 200));
			var $showFullTextTemplate = $('.show-full-text').first().clone();

			if (!$showFullTextTemplate.length) {
				return;
			}

			$showFullTextTemplate.find('.more-text').text(fullText.slice(200)).hide();
			$textElement.append($showFullTextTemplate);
			$showFullTextTemplate.show();
			$textElement.on('click', '.show-full-text', function() {
				$(this).replaceWith($(this).find('.more-text').text());
			});
		} else if ($existingShowFullText.length) {
			var moreText = $existingShowFullText.find('.more-text').text();
			$existingShowFullText.replaceWith(moreText);
		}
	});
}

/**
 * @private
 * @function
 * @description Adds class ('js') to html for css targeting and loads js specific styles.
 */
function initializeDom() {
	// add class to html for css targeting
	$('html').addClass('js');
	// load js specific styles
	util.limitCharatersCounter();
	util.limitCharacters();
	util.initCharactersCount();
	// this form subbmitted with default button, so no need to check if it's inited
	reCaptcha.initRecaptchaOnForm('#custom-form');
}

var global = {
	init: function () {
		contentloader.init();
		if (document.cookie.length === 0) {
			$('<div/>').addClass('browser-compatibility-alert').append($('<p/>').addClass('browser-error').html(Resources.COOKIES_DISABLED)).appendTo('#browser-check');
		}
		initializeDom();
		initializeEvents();
		// init specific global components
		countries.init();
		tooltip.init();
		minicart.init();
		validator.init();
		rating.init();
		searchplaceholder.init();
		multicurrency.init();
		loqate.load();
		cq.init();
		emailsignup.init();

		// Functions for Navigation
		navigation.init();
		stickup.init();
		iscrollexample.init();

		// Check TLS status if indicated by site preference
		if (SitePreferences.CHECK_TLS === true) {
			tls.getUserAgent();
		}
		// Init lazy load if switched on
		if (SitePreferences.LAZYLOAD_ENABLED) {
			lazyloading.init();
		}
		// AmazonPay init
		amazonpay.amazonPaymentsObject.init();

		wishlist.initCurrentCustomerWishlist();

		global.initZmagsCreator();
		global.initEcomBridge();

		cjcookie.removeCJCookie();
	},

	initZmagsCreator: function () {
		window.__zmags.demandware.quickview = quickview;
		window.__zmags.demandware.analytics.creator.init = window.__zmags.demandware.analytics.creator.init || require('int_zmagscreator/../static/default/js/zmags-creator-analytics.js');
		window.__zmags.demandware.analytics.creator.init();
	},

	initEcomBridge: function () {
		ecommBridge.capability.hasQuickView = window.hasQuickview;
		ecommBridge.capability.hasWishList = window.hasWishlist;
		ecommBridge.capability.isTransactional = window.isTransactional;
		ecommBridge.site.locale = window.currentLocale;
		ecommBridge.site.currency.code = window.currencyCode;
		ecommBridge.site.currency.prefix = window.currencyIsPrefix ? window.currencySymbol : '';
		ecommBridge.site.currency.suffix = window.currencyIsPrefix ? '' : window.currencySymbol;
		ecommBridge.site.page = window.pageData;
		ecommBridge.user.name = window.user;
	}
};

// general extension functions
(function () {
	String.format = function () {
		var s = arguments[0];
		var i, len = arguments.length - 1;
		for (i = 0; i < len; i++) {
			var reg = new RegExp('\\{' + i + '\\}', 'gm');
			s = s.replace(reg, arguments[i + 1]);
		}
		return s;
	};
})();

module.exports = global;
